import { assign } from 'lodash';
import posthog from 'posthog-js';
import type { Role, SelfUserApplicationStatus } from '../types/User';

const MERCANTILE_EMAIL_DOMAIN = '@getmercantile.com';

export const getIsMercantileUser = (email?: string) =>
  Boolean(email?.endsWith(MERCANTILE_EMAIL_DOMAIN));

type SetUserParams = {
  auth0Id: string;
  accountId?: string;
  businessId?: string;
  userId?: string;
  applicationStatus?: SelfUserApplicationStatus;
  role?: Role | null;
  email?: string;
  pushNotificationsEnabled?: boolean;
};

/**
 *  Set the user in Sentry and PostHog with properties derived from the provided parameters
 * @param SetUserParams - Parameters that will be used to set the user in Sentry and PostHog
 */
export const setUser = ({
  auth0Id,
  accountId,
  businessId,
  userId,
  applicationStatus,
  role,
  email,
  pushNotificationsEnabled,
}: SetUserParams) => {
  const isMercantile = getIsMercantileUser(email);
  const monitoringUser = assign(
    { auth0Id },
    accountId && { accountId },
    businessId && { businessId },
    userId && { userId },
    applicationStatus && { applicationStatus },
    role && { role },
    isMercantile && { isMercantile },
    { pushNotificationsEnabled: Boolean(pushNotificationsEnabled) },
  );
  posthog.identify(auth0Id, monitoringUser);
};

export const removeUser = () => {
  posthog.reset();
};

export const addError = (error: unknown, additionalProps: Record<string, any> = { error }) => {
  posthog.captureException(error, { extra: additionalProps });
};
